import { render } from "./NewSystemUser.vue?vue&type=template&id=63a008ea&scoped=true"
import script from "./NewSystemUser.vue?vue&type=script&lang=js"
export * from "./NewSystemUser.vue?vue&type=script&lang=js"

import "./NewSystemUser.vue?vue&type=style&index=0&id=63a008ea&scoped=true&lang=css"

import exportComponent from "/Users/onisiforosgeorgiou/WebstormProjects/AgencyNow/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63a008ea"]])

export default __exports__